
import subAdminDashboard from './customerDashboard';
import superAdminDashboard from './superAdminDashboard';
import superMostAdminDashboard from './superMostAdminDashboard';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  // items: [dashboard]
  subAdmin : [subAdminDashboard],
  superAdmin : [superAdminDashboard],
  superMostAdmin: [superMostAdminDashboard]
};

export default menuItems;
